import { render, staticRenderFns } from "./FacebookReview.vue?vue&type=template&id=59741e95&"
import script from "./FacebookReview.vue?vue&type=script&lang=js&"
export * from "./FacebookReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports